module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "all-wrapper",
    attrs: {
      "id": "app"
    }
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('div', {
    staticClass: "container main-contents"
  }, [_vm._m(0), _c('router-view'), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('transition', {
    attrs: {
      "name": "notifyFade"
    }
  }, [(_vm.notifications !== null) ? _c('div', {
    staticClass: "notify-message-parent"
  }, _vm._l((_vm.notifications), function(notification) {
    return _c('div', {
      staticClass: "notify-message"
    }, [_c('div', {
      staticClass: "alert alert-dismissible",
      class: {
        'alert-success': notification.success, 'alert-danger': notification.danger, 'alert-warning': notification.warning
      }
    }, [_c('a', {
      staticClass: "close",
      attrs: {
        "href": "#",
        "data-dismiss": "alert",
        "aria-label": "close",
        "title": "close"
      }
    }, [_vm._v("×")]), ('message_i18n' in notification) ? _c('p', {
      staticClass: "notify-msg"
    }, [_vm._v(_vm._s(_vm.$t(notification.message_i18n)))]) : _vm._e(), ('message_direct' in notification) ? _c('p', {
      staticClass: "notify-msg"
    }, [_vm._v(_vm._s(notification.message_direct))]) : _vm._e()])])
  })) : _vm._e()])], 1)])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "commonAjaxLoading"
    }
  }, [_c('p', [_vm._v("loading...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6ffd36ed!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/app.pug
// module id = 400
// module chunks = 1